import { Injectable } from '@angular/core';

import { environment } from '../environments/environment';

@Injectable()
export class UriConfig {
  baseApiUrl = environment.apiUrl;

  answerGroups = `${this.baseApiUrl}answer-groups`;

  auth = `${this.baseApiUrl}auth`;

  logout = `${this.baseApiUrl}auth/logout`;

  refresh = `${this.baseApiUrl}auth/refresh`;

  brands = `${this.baseApiUrl}brands`;

  user = `${this.baseApiUrl}vendors`;

  files = `${this.baseApiUrl}files`;

  login = `${this.baseApiUrl}auth/signin`;

  validateResetToken = `${this.baseApiUrl}auth/validate-reset-password`;

  resetPassword = `${this.baseApiUrl}auth/reset-password`;

  restorePassword = `${this.baseApiUrl}auth/restore-password`;

  changePassword = `${this.baseApiUrl}auth/change-password`;

  rounds = `${this.baseApiUrl}rounds`;

  sportEvents = `${this.baseApiUrl}sports-events`;

  externalSportEvents = `${this.baseApiUrl}sports-events/external`;

  answers = `${this.baseApiUrl}answers`;

  questionsList = `${this.baseApiUrl}questions/list`;

  questions = `${this.baseApiUrl}questions`;

  questionsAutoResulting = `${this.baseApiUrl}questions/auto-resulting`;

  teams = `${this.baseApiUrl}teams`;

  correctAnswers = `${this.baseApiUrl}answers/correct`;

  analytics = `${this.baseApiUrl}analytics`;

  analyticsReport = `${this.baseApiUrl}analytics/detailed`;

  analyticsMonthlyGameReport = `${this.baseApiUrl}analytics/monthly`;

  admins = `${this.baseApiUrl}admins`;

  vendors = `${this.baseApiUrl}vendors`;

  settings = `${this.baseApiUrl}settings`;

  leaderboards = `${this.baseApiUrl}leaderboards`;

  vendorAnalytic = `${this.baseApiUrl}analytics/vendor`;

  localizations = `${this.baseApiUrl}localizations`;

  locales = `${this.baseApiUrl}locales`;

  slackSettings = `${this.baseApiUrl}app-settings`;

  roundCreationInstructions = `${this.baseApiUrl}round-creation-instructions`;

  cmsContent = `${this.baseApiUrl}cms/content`;

  cms = `${this.baseApiUrl}cms`;

  infoPopupTabs = `${this.baseApiUrl}info-popup-tabs`;

  questionsStreak = `${this.baseApiUrl}questions/streak`;

  streakRounds = `${this.baseApiUrl}rounds/streak`;

  upsellBanners = `${this.baseApiUrl}upsell-banners`;

  whitelistedUsers = `${this.baseApiUrl}maintenance-mode-white-list`;

  maintenanceMode = `${this.baseApiUrl}maintenance-mode`;

  popularBets = `${this.baseApiUrl}popular-boosted-bets`;

  sse = `${this.baseApiUrl}sse`;

  bracketRounds = `${this.baseApiUrl}rounds/bracket/gs-and-knockouts`;

  brackets = `${this.baseApiUrl}rounds/brackets`;

  challengeBlocks = `${this.baseApiUrl}challenge-blocks`;

  challenges = `${this.baseApiUrl}challenges`;

  tournaments = `${this.baseApiUrl}tournaments`;

  segments = `${this.baseApiUrl}segments`;

  streakLadder = `${this.baseApiUrl}streak-ladders`;

  settingGroups = `${this.baseApiUrl}setting-groups`;

  b2cTabs = `${this.baseApiUrl}b2c-tabs`;

  connect3 = `${this.baseApiUrl}connect3`;

  sheetsBlocks = `${this.baseApiUrl}connect3/sheets-blocks`;

  sheets = `${this.baseApiUrl}connect3/sheets`;

  connect3Rounds = `${this.baseApiUrl}rounds/connect3`;

  markets = `${this.baseApiUrl}markets`;

  marketsFamily = `${this.baseApiUrl}markets/families`;

  featureFlags = `${this.baseApiUrl}feature-flags`;

  passTheBallRounds = `${this.baseApiUrl}rounds/ptb`;

  passTheBallGroups = `${this.baseApiUrl}ptb/groups`;

  streakPowerups = `${this.baseApiUrl}streak/powerups`;

  moneyHeistRounds = `${this.baseApiUrl}rounds/mh`;

  streakLadderPowerups = `${this.baseApiUrl}streak-ladders/powerups`;

  superbetCampaigns = `${this.baseApiUrl}superbet-api/campaigns`;

  super13Rounds = `${this.baseApiUrl}rounds/super13`;
}
